import { trackEventNext } from "@kunduz/utility-analytics";
import React, { ReactElement, useState } from "react";
import { useTranslation } from "next-i18next";
import { type IContent } from "@kunduz/data-access-cms-api";
import axios from "axios";
import { UserReviews } from "@kunduz/ui-components";

export const UserReviewsWithContext = (props: Props): ReactElement => {
  const { t } = useTranslation("kunduzcom_common");
  const [nextUrl, setNextUrl] = useState(props.data.items.next);
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState(props.data.items.results);

  const handleLoadMoreClicked = async () => {
    if (!nextUrl) return;
    trackEventNext({
      event: "User Review Show More Button Clicked",
    });
    setLoading(true);
    const response = await axios.get(nextUrl);
    setNextUrl(response.data.next);
    setReviews((oldReviews) => [...oldReviews, ...response.data.results]);
    setLoading(false);
  };

  const handleShowMoreClicked = (user: any) => {
    trackEventNext({
      event: "User Review Expanded",
      user,
    });
  };

  return (
    <UserReviews
      id={props.data.anchor_tag}
      componentData={props.data}
      reviews={reviews}
      onLoadMoreClicked={handleLoadMoreClicked}
      onShowMoreClicked={handleShowMoreClicked}
      nextUrl={nextUrl}
      loading={loading}
      loadMoreLabel={t("user_review_component_cta_button_label")}
    />
  );
};

interface Props {
  data: IContent.UserReviewComponentData;
}
